import { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

export default function Login() {
  const [tab, setTab] = useState('merchant');

  const inputClass =
    'w-full px-4 py-3 rounded-2xl border border-gray-200 bg-white text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-amber-400 transition-shadow shadow-[0_2px_10px_rgba(15,23,42,0.03)]';

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8F7F4] px-4 pb-8 pt-20 sm:py-10 sm:pt-24">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md overflow-hidden rounded-[32px] border border-gray-200 bg-white shadow-[0_18px_50px_rgba(15,23,42,0.08)]"
      >
        <div className="relative overflow-hidden bg-[#0F172A] px-6 py-8 sm:px-8 sm:py-10">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(251,191,36,0.14),transparent_30%),radial-gradient(circle_at_bottom_left,rgba(251,191,36,0.08),transparent_24%)]" />
          <div className="relative text-center">
            <div className="mx-auto mb-5 h-px w-24 bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
            <Logo scrolled={false} forceWhite={true} />
          </div>
        </div>

        <div className="p-6 sm:p-8">
          <div className="mb-6 grid grid-cols-2 rounded-2xl border border-gray-200 bg-[#F8F7F4] p-1.5 sm:mb-8">
            {['merchant', 'broker'].map((t) => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`rounded-xl py-2.5 text-sm font-semibold transition-all ${
                  tab === t
                    ? 'bg-[#0F172A] text-white shadow-[0_8px_18px_rgba(15,23,42,0.14)]'
                    : 'text-gray-600 hover:bg-white'
                }`}
              >
                {t === 'merchant' ? 'Merchant Login' : 'Broker Portal'}
              </button>
            ))}
          </div>

          <form className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Email</label>
              <input
                type="email"
                placeholder="you@business.com"
                className={inputClass}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
              <input
                type="password"
                placeholder="••••••••"
                className={inputClass}
              />
            </div>

            <button
              type="button"
              className="w-full rounded-full bg-[#0F172A] hover:bg-[#111c33] text-white font-bold py-3.5 transition-all duration-300 shadow-[0_12px_28px_rgba(15,23,42,0.16)]"
            >
              Sign In
            </button>
          </form>

          <div className="mt-6 text-center text-sm text-gray-500 space-y-2">
            <p>
              <a href="#" className="text-amber-700 hover:text-amber-800 hover:underline">
                Forgot password?
              </a>
            </p>
            <p>
              Don't have an account?{' '}
              <Link to="/apply" className="text-amber-700 hover:text-amber-800 hover:underline font-medium">
                Apply for Funding
              </Link>
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
